import { render } from "./tag.vue?vue&type=template&id=24d2e320"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"

import "./tag.vue?vue&type=style&index=0&id=24d2e320&lang=css"
script.render = render

export default script